import { AxiosInstance } from 'axios';
import { PopupGateway } from '../domain/popup.gateway';
import { PopupPortal } from '../domain/popup.entities';
import { Paths } from './keys';

export class PopupHttpGateway implements PopupGateway {
    constructor(private http: AxiosInstance) {}

    async getPopup(): Promise<PopupPortal | null> {
        try {
            console.log('[Popup] Buscando parâmetro em:', Paths.default);
            const response = await this.http.get(Paths.default);
            console.log('[Popup] Resposta da API:', response?.status, JSON.stringify(response?.data));
            if (response?.status === 200 && response.data !== null && response.data !== undefined && response.data !== '') {
                const result = {
                    text: response.data.text || '',
                    enabled: response.data.enabled === true || response.data.enabled === 'true',
                };
                console.log('[Popup] Resultado parseado:', JSON.stringify(result));
                return result;
            }
            console.warn('[Popup] Resposta inesperada:', response?.status);
            return null;
        } catch (error: any) {
            console.error('[Popup] Erro ao buscar popup:', error?.response?.status, error?.response?.data || error?.message);
            return null;
        }
    }
}
